export function getStatusLabel(programProgress: { status: string }): string {
  switch (programProgress.status) {
    case 'not_started':
      return 'Not Started';
    case 'in_progress':
      return 'In Progress';
    case 'paused':
      return 'Paused';
    case 'finished':
      return 'Finished';
    default:
      throw new Error(`Unknown ProgramStatus: ${programProgress.status}`);
  }
}

export const getStatusColor = (programProgress: { status: string }) => {
  switch (programProgress.status) {
    case 'not_started':
      return 'default';
    case 'in_progress':
      return 'info';
    case 'paused':
      return 'warning';
    case 'finished':
      return 'success';
    default:
      throw new Error(`Unknown ProgramStatus: ${programProgress.status}`);
  }
};
